// customer360PageSlice.js
import {createSlice} from '@reduxjs/toolkit';

const customer360PageSlice = createSlice({
  name: 'customer360Page',
  initialState: {
    formValues: {
      customerId: '',
      customerName: '',
      mobileNumber: '',
      ucicNo: '',
      branch: [],
      platformName: '',
      kyc: '',
      kycValue: '',
    },
    customerData: [],
    totalPages: 0,
    currentPage: 1,
    searchAttempted: false,
    branchListing: [],
    kycDocumentList: [],
  },
  reducers: {
    setCustomer360FormValues: (state, action) => {
      state.formValues = action.payload;
    },
    setCustomer360CustomerData: (state, action) => {
      state.customerData = action.payload;
    },
    setCustomer360TotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setCustomer360CurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setCustomer360SearchAttempted: (state, action) => {
      state.searchAttempted = action.payload;
    },
    setCustomer360BranchListing: (state, action) => {
      state.branchListing = action.payload;
    },
    setCustomer360KycDocumentList: (state, action) => {
      state.kycDocumentList = action.payload;
    },
    resetCustomer360Page: state => {
      console.log(
        'resetCustomer360Page reducer: Resetting Customer 360 page state.',
      );
      state.formValues = {
        customerId: '',
        customerName: '',
        mobileNumber: '',
        ucicNo: '',
        branch: [],
        platformName: '',
        kyc: '',
        kycValue: '',
      };
      state.customerData = [];
      state.totalPages = 0;
      state.currentPage = 1;
      state.searchAttempted = false;
      state.branchListing = [];
      state.kycDocumentList = [];
    },
  },
});

export const {
  setCustomer360FormValues,
  setCustomer360CustomerData,
  setCustomer360TotalPages,
  setCustomer360CurrentPage,
  setCustomer360SearchAttempted,
  setCustomer360BranchListing,
  setCustomer360KycDocumentList,
  resetCustomer360Page,
} = customer360PageSlice.actions;

export default customer360PageSlice.reducer;
